// MorrCart app-icon tile (M monogram). Renders a rounded white tile so the mark
// reads cleanly on both light and dark backgrounds.
export function MorrMark({ size = 28, className = "" }) {
  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center bg-white rounded-md overflow-hidden shadow-sm ${className}`}
      style={{ width: size, height: size }}
      data-testid="morr-mark"
      aria-label="MorrCart"
    >
      <img
        src="/favicon-256.png"
        alt="MorrCart"
        style={{ width: "100%", height: "100%", objectFit: "contain" }}
      />
    </span>
  );
}

export default MorrMark;
